import * as React from 'react';
import axios from 'axios';
import CashierPayAppLazy from '../CashierPayAppLazy/CashierPayAppLazy';

export default class CashierPayAppWrapper extends React.Component {
  //private manifestUrt = 'https://ecom.wix.com/_api/cashier-settings-server/payments-widget-manifest';
  private manifestUrt = '/_api/cashier-settings-server/payments-widget-manifest';

    state = {
            manifest: null,
    };

    componentDidMount() {
        axios.get(this.manifestUrt)
            .then((response) => {
                const manifest = {...response.data, component: 'CashierPayApp'};
                this.setState({manifest});
            })
            .catch((error) => {
                //    console.log("axios error - ", error);
            });
    }

    render() {
        return this.state.manifest ? <CashierPayAppLazy manifest={this.state.manifest}/> : null;
    }
}



// WEBPACK FOOTER //
// ./CashierPayAppWrapper/CashierPayAppWrapper.tsx